import React from 'react'
import Login from '../../components/Account/Login'

const LoginPage = () => {
  return (
    <div>
        <Login />
    </div>
  )
}

export default LoginPage